import { ReactNode } from "react";
import { cn } from "~/lib/utils";

type Props = {
    children?: ReactNode;
    className?: string;
}

export const Container = ({ children, className }: Props) => {
    return (
        <div className={cn(
            "w-full mx-auto max-w-[1600px]",
            "px-6 md:px-12 xl:px-16 min-[1440px]:px-20",
            className
        )}>{children}</div>
    );
};

export default Container;
